import React from "react";

function HomePage() {
  return (
    <div className="middle">
      <h1>Made by horn players</h1>
      <h1>For horn players</h1>
    </div>
  );
}

export default HomePage;
